export const StatusEnum = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
};

export const ChannelAllowEnum = {
  Basic: "Basic",
  OAuth: "OAuth",
};

export const ChannelAllowTypeEnum = {
  Email: "Email",
  Phone: "Phone",
  AD: "AD",
  Facebook: "Facebook",
  Google: "Google",
};
